import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initAttribution } from './lib/attribution';
import { installAnalyticsTransport } from './lib/analyticsTransport';
import './styles/theme.css';

/**
 * Capture acquisition attribution before the first render (spec section 16).
 *
 * It has to happen here rather than inside a component, because the record is
 * meant to describe the URL the session *landed* on. Most provider traffic
 * arrives via joinherdbook.com, which 301s to /providers with the query string
 * intact, and the visitor may well read two other pages before they fill
 * anything in — by which point `location.search` is long gone. Captured once,
 * per session, and never overwritten (see lib/attribution.ts).
 */
initAttribution();

/**
 * Point `track()` at `POST /api/events` (spec sections 14, 16).
 *
 * After `initAttribution()` on purpose: every event carries the session id from
 * the attribution record, so the two describe the same session. Installed
 * before the first render so an event fired during mount is not lost to the
 * development no-op transport.
 *
 * First-party events are the authoritative record. Plausible, when
 * `PLAUSIBLE_DOMAIN` is configured, is complementary and receives no custom
 * events from this app (spec section 16).
 */
installAnalyticsTransport();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
